import { createApi } from "@reduxjs/toolkit/query/react";
import { IBillListDTO } from "../../Interfaces/Bill";
import { baseAuthQuery } from "../baseAuthQuery";

export const BillApi = createApi({
  reducerPath: "BillApi",
  baseQuery: baseAuthQuery,
  tagTypes: ["Bill"],
  endpoints: (builder) => ({
    createBillFromOffer: builder.mutation<IBillListDTO, number>({
      query: (offerId: number) => ({
        url: `/Bill/${offerId}`,
        method: "POST",
      }),
    }),
    duplicateOffer: builder.mutation<IBillListDTO, number>({
      query: (offerId: number) => ({
        url: `/Bill/duplicateOffer/${offerId}`,
        method: "POST",
      }),
    }),
    getMostRecentBill: builder.query<IBillListDTO, void>({
      query: () => ({
        url: `/Bill/mostRecentBill`,
        method: "GET",
        providesTags: (result: IBillListDTO) => [
          { type: "Bill", id: result.bill.id },
        ],
      }),
    }),
    getMostRecentOffer: builder.query<IBillListDTO, void>({
      query: () => ({
        url: `/Bill/mostRecentOffer`,
        method: "GET",
        providesTags: (result: IBillListDTO) => [
          { type: "Bill", id: result.bill.id },
        ],
      }),
    }),
    getMostRecentReceipt: builder.query<IBillListDTO, void>({
      query: () => ({
        url: `/Bill/mostRecentReceipt`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useCreateBillFromOfferMutation,
  useGetMostRecentBillQuery,
  useGetMostRecentOfferQuery,
  useGetMostRecentReceiptQuery,
  useDuplicateOfferMutation,
} = BillApi;
